import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Settings({ color = 'icon.primary', fill = 'transparent', ...props }) {
  return (
    <IconBase viewBox='0 0 22 22' {...props}>
      <Path
        d='M1 12.1111V4.33333C1 2.49222 2.49222 1 4.33333 1H17.6667C19.5078 1 21
         2.49222 21 4.33333V17.6667C21 19.5078 19.5078 21 17.6667 21H11'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.54028 10.2006L11.7414 12.4017L14.8881 9.32836C14.9292 9.28836 14.9981
         9.3017 15.0225 9.35281C15.8369 11.0939 15.4558 13.2384 14.0169 14.6761C12.6236
          16.0695 10.6425 16.4361 8.95472 15.7761L4.32028 20.4106C3.56028 21.1695 2.32806
           21.1695 1.56917 20.4106C0.810278 19.6506 0.810278 18.4184 1.56917 17.6595L6.16695
            13.0617C5.50583 11.375 5.87361 9.39392 7.26695 7.99947C8.7025 6.56392 10.8425
             6.2517 12.5847 6.99725C12.6369 7.02059 12.6503 7.0917 12.6103 7.13281L9.54028 10.2006Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
    </IconBase>
  )
}

Settings.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  fill: PropTypes.string,
}

export default Settings
